import { render } from "./TopLevelMenuItemView.vue?vue&type=template&id=b4ea7364&scoped=true"
import script from "./TopLevelMenuItemView.vue?vue&type=script&lang=js"
export * from "./TopLevelMenuItemView.vue?vue&type=script&lang=js"

import "./TopLevelMenuItemView.vue?vue&type=style&index=0&id=b4ea7364&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ea7364"]])

export default __exports__